// src/pages/BookingCart.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BookingCart = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('cart');
    const [selectedItems, setSelectedItems] = useState([1, 2]);
    const [promoCode, setPromoCode] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('wechat');

    // 购物车项目
    const cartItems = [
        {
            id: 1,
            type: 'hotel',
            name: 'Fairmont The Queen Elizabeth',
            location: 'Downtown Montreal',
            details: 'Deluxe Room, City View',
            checkIn: 'Dec 20',
            checkOut: 'Dec 22',
            nights: 2,
            features: ['Free WiFi', 'Breakfast', 'Pool'],
            rating: 4.8,
            reviews: 1240,
            originalPrice: 1299,
            discountPrice: 899,
            selected: true,
            image: 'https://media-cdn.tripadvisor.com/media/photo-s/14/7a/b7/40/exterior.jpg',
        },
        {
            id: 2,
            type: 'activity',
            name: 'Old Montreal Walking Tour',
            location: 'Historic District CA1502',
            duration: '3 hours',
            date: 'Dec 22, 14:30 - 16:45',
            features: ['Tour Guide', 'Free Entry', 'Equipment'],
            rating: 4.6,
            reviews: 890,
            price: 680,
            quantity: 2,
            selected: true,
            image: 'https://media.tacdn.com/media/attractions-splice-spp-674x446/15/4c/76/ae.jpg',
        }
    ];

    // 推荐项目
    const recommendations = [
        {
            id: 3,
            name: 'Underground City Tour',
            type: 'Activity',
            location: 'RESO District',
            features: ['Professional Guide', 'All Weather', 'WiFi'],
            rating: 4.7,
            reviews: 340,
            price: 120,
            image: 'https://media.tacdn.com/media/attractions-splice-spp-674x446/07/1c/b3/41.jpg',
        },
        {
            id: 4,
            name: 'Montreal Food Tour',
            type: 'Dining',
            duration: '2.5 hours',
            features: ['Tastings', 'Expert Guide', 'Free Drinks'],
            rating: 4.5,
            reviews: 2100,
            price: 368,
            image: 'https://www.seesight-tours.com/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fsee-sight-tours%2Fimage%2Fupload%2Fv1678811345%2Fstrapi%2F1_Hero_Image_Poutine_a46ba4e861.jpg&w=2048&q=80',
        }
    ];

    const calculateTotal = () => {
        const subtotal = 1739;
        const discount = -400;
        return subtotal + discount;
    };

    return (
        <>
            <style>{`
        .booking-container {
          width: 100%;
          max-width: 430px;
          height: 100vh;
          margin: 0 auto;
          background: #f8f8f8;
          display: flex;
          flex-direction: column;
          position: relative;
        }
        
        /* Header */
        .booking-header {
          background: white;
          padding: 50px 16px 0;
          border-bottom: 1px solid #f0f0f0;
          position: sticky;
          top: 0;
          z-index: 10;
        }
        
        .header-nav {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
        }
        
        .back-btn {
          width: 32px;
          height: 32px;
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #333;
        }
        
        .header-title {
          flex: 1;
          text-align: center;
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
          margin-right: 32px;
        }
        
        .desktop-view {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: #f5f5f5;
          border-radius: 8px;
          font-size: 12px;
          color: #666;
        }
        
        /* Tabs */
        .booking-tabs {
          display: flex;
          padding: 12px 0;
        }
        
        .tab-btn {
          flex: 1;
          padding: 8px;
          background: none;
          border: none;
          font-size: 14px;
          color: #999;
          cursor: pointer;
          position: relative;
        }
        
        .tab-btn.active {
          color: #333;
          font-weight: 500;
        }
        
        .tab-btn.active::after {
          content: '';
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          width: 24px;
          height: 2px;
          background: #333;
        }
        
        /* Content */
        .booking-content {
          flex: 1;
          overflow-y: auto;
          padding-bottom: 140px;
        }
        
        /* Cart Item */
        .cart-item {
          background: white;
          margin: 12px 16px;
          border-radius: 12px;
          padding: 14px;
          position: relative;
        }
        
        .item-header {
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
        }
        
        .item-image {
          width: 80px;
          height: 60px;
          background: #e8e8e8;
          border-radius: 8px;
          object-fit: cover;
        }
        
        .item-info {
          flex: 1;
        }
        
        .item-type {
          font-size: 11px;
          color: #667eea;
          font-weight: 500;
          margin-bottom: 4px;
        }
        
        .item-name {
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 2px;
        }
        
        .item-location {
          font-size: 12px;
          color: #888;
        }
        
        .item-details {
          display: flex;
          gap: 12px;
          font-size: 12px;
          color: #666;
          margin-bottom: 8px;
        }
        
        .item-features {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          margin-bottom: 8px;
        }
        
        .feature-tag {
          font-size: 11px;
          padding: 3px 8px;
          background: #f5f5f5;
          border-radius: 4px;
          color: #666;
        }
        
        .item-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .item-rating {
          display: flex;
          align-items: center;
          gap: 6px;
        }
        
        .stars {
          color: #ffc107;
          font-size: 12px;
        }
        
        .rating-text {
          font-size: 12px;
          color: #666;
        }
        
        .item-price {
          text-align: right;
        }
        
        .original-price {
          font-size: 12px;
          color: #999;
          text-decoration: line-through;
        }
        
        .current-price {
          font-size: 16px;
          font-weight: 500;
          color: #ff4444;
        }
        
        .quantity-control {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .qty-btn {
          width: 24px;
          height: 24px;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        
        /* Recommendations */
        .recommendations {
          padding: 0 16px;
        }
        
        .section-title {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin: 16px 0 12px;
        }
        
        .reco-item {
          background: white;
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 12px;
          display: flex;
          gap: 12px;
          align-items: center;
        }
        
        .reco-image {
          width: 60px;
          height: 60px;
          background: #e8e8e8;
          border-radius: 8px;
        }
        
        .reco-info {
          flex: 1;
        }
        
        .reco-name {
          font-size: 14px;
          font-weight: 500;
          color: #1a1a1a;
          margin-bottom: 4px;
        }
        
        .reco-details {
          font-size: 12px;
          color: #888;
          margin-bottom: 4px;
        }
        
        .reco-price {
          font-size: 14px;
          font-weight: 500;
          color: #ff4444;
        }
        
        .add-btn {
          padding: 6px 16px;
          background: #2d2d2d;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 12px;
          cursor: pointer;
        }
        
        /* Order Summary */
        .order-summary {
          background: white;
          margin: 16px;
          border-radius: 12px;
          padding: 16px;
        }
        
        .summary-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 14px;
          color: #666;
        }
        
        .summary-row.total {
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #f0f0f0;
          font-size: 16px;
          font-weight: 500;
          color: #1a1a1a;
        }
        
        .discount {
          color: #4caf50;
        }
        
        .total-price {
          color: #ff4444;
        }
        
        /* Promo Code */
        .promo-section {
          margin: 16px;
          padding: 12px;
          background: white;
          border-radius: 12px;
        }
        
        .promo-input {
          display: flex;
          gap: 8px;
        }
        
        .promo-field {
          flex: 1;
          padding: 10px 12px;
          background: #f8f8f8;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          outline: none;
        }
        
        .promo-btn {
          padding: 10px 20px;
          background: #667eea;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          cursor: pointer;
        }
        
        /* Payment Methods */
        .payment-section {
          background: white;
          margin: 16px;
          border-radius: 12px;
          padding: 16px;
        }
        
        .payment-option {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px;
          background: #f8f8f8;
          border-radius: 8px;
          margin-bottom: 8px;
          cursor: pointer;
        }
        
        .payment-option.active {
          background: #e8f0fe;
          border: 1px solid #667eea;
        }
        
        .payment-info {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .payment-icon {
          width: 32px;
          height: 32px;
          background: white;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        /* Contact Info */
        .contact-section {
          background: white;
          margin: 16px;
          border-radius: 12px;
          padding: 16px;
        }
        
        .contact-input {
          width: 100%;
          padding: 10px 12px;
          background: #f8f8f8;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          margin-bottom: 8px;
          outline: none;
        }
        
        /* Security Notice */
        .security-notice {
          margin: 16px;
          padding: 12px;
          background: #e8f5e9;
          border-radius: 8px;
          font-size: 12px;
          color: #4caf50;
          text-align: center;
        }
        
        /* Fixed Checkout */
        .checkout-bar {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          max-width: 430px;
          margin: 0 auto;
          background: white;
          border-top: 1px solid #f0f0f0;
          padding: 12px 16px;
          padding-bottom: max(12px, env(safe-area-inset-bottom));
          display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 20;
        }
        
        .checkout-total {
          font-size: 18px;
          font-weight: 500;
          color: #ff4444;
        }
        
        .checkout-btn {
          padding: 12px 32px;
          background: #2d2d2d;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
        }
      `}</style>

            <div className="booking-container">
                {/* Header */}
                <div className="booking-header">
                    <div className="header-nav">
                        <button className="back-btn" onClick={() => navigate(-1)}>
                            <i className="bi bi-arrow-left"></i>
                        </button>
                        <div className="header-title">Booking Service</div>

                    </div>

                    <div className="booking-tabs">
                        <button
                            className={`tab-btn ${activeTab === 'cart' ? 'active' : ''}`}
                            onClick={() => setActiveTab('cart')}
                        >
                            Shopping Cart
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'recommend' ? 'active' : ''}`}
                            onClick={() => setActiveTab('recommend')}
                        >
                            Recommend
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'checkout' ? 'active' : ''}`}
                            onClick={() => setActiveTab('checkout')}
                        >
                            Checkout
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="booking-content">
                    {activeTab === 'cart' && (
                        <>
                            {cartItems.map(item => (
                                <div key={item.id} className="cart-item">
                                    <div className="item-header">
                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                            <img className="item-image" src={item.image} alt={item.name} />
                                        </a>
                                        <div className="item-info">
                                            <div className="item-type">{item.type.toUpperCase()}</div>
                                            <div className="item-name">{item.name}</div>
                                            <div className="item-location">{item.location}</div>
                                        </div>
                                    </div>

                                    <div className="item-details">
                                        {item.checkIn && <span>Check-in: {item.checkIn}</span>}
                                        {item.checkOut && <span>Check-out: {item.checkOut}</span>}
                                        {item.duration && <span>Duration: {item.duration}</span>}
                                        {item.date && <span>{item.date}</span>}
                                    </div>

                                    <div className="item-features">
                                        {item.features.map((feat, i) => (
                                            <span key={i} className="feature-tag">{feat}</span>
                                        ))}
                                    </div>

                                    <div className="item-footer">
                                        <div className="item-rating">
                                            <span className="stars">★★★★★</span>
                                            <span className="rating-text">{item.rating} ({item.reviews})</span>
                                        </div>

                                        <div className="item-price">
                                            {item.originalPrice && (
                                                <div className="original-price">${item.originalPrice}</div>
                                            )}
                                            <div className="current-price">
                                                ${item.discountPrice || item.price}
                                            </div>
                                        </div>

                                        {item.quantity && (
                                            <div className="quantity-control">
                                                <button className="qty-btn">−</button>
                                                <span>{item.quantity}</span>
                                                <button className="qty-btn">+</button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}

                            {/* Order Summary */}
                            <div className="order-summary">
                                <div className="summary-row">
                                    <span>Subtotal</span>
                                    <span>$2139</span>
                                </div>
                                <div className="summary-row discount">
                                    <span>Discount</span>
                                    <span>-$400</span>
                                </div>
                                <div className="summary-row total">
                                    <span>Total</span>
                                    <span className="total-price">$1739</span>
                                </div>
                            </div>
                        </>
                    )}

                    {activeTab === 'recommend' && (
                        <div className="recommendations">
                            <div className="section-title">Recommended for You</div>
                            {recommendations.map(item => (
                                <div className="reco-item">
                                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                                        <img className="reco-image" src={item.image} alt={item.name} />
                                    </a>
                                    <div className="reco-info">
                                        <div className="reco-name">{item.name}</div>
                                        <div className="reco-details">{item.type} • {item.location || item.duration}</div>
                                        <div className="item-rating">
                                            <span className="stars">★★★★★</span>
                                            <span className="rating-text">{item.rating} ({item.reviews})</span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="reco-price">${item.price}</div>
                                        <button className="add-btn">Add</button>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}

                    {activeTab === 'checkout' && (
                        <>
                            {/* Order Summary */}
                            <div className="order-summary">
                                <div className="section-title" style={{ marginBottom: '12px' }}>Order Confirmation</div>
                                <div className="summary-row">
                                    <span>Fairmont Hotel</span>
                                    <span>$899</span>
                                </div>
                                <div className="summary-row">
                                    <span>Walking Tour - 2 persons</span>
                                    <span>$680</span>
                                </div>
                                <div className="summary-row">
                                    <span>Service Fee</span>
                                    <span>$160</span>
                                </div>
                                <div className="summary-row total">
                                    <span>Total</span>
                                    <span className="total-price">$1739</span>
                                </div>
                            </div>

                            {/* Promo Code */}
                            <div className="promo-section">
                                <div className="section-title" style={{ marginBottom: '12px' }}>Promo Code</div>
                                <div className="promo-input">
                                    <input
                                        className="promo-field"
                                        placeholder="Enter promo code"
                                        value={promoCode}
                                        onChange={(e) => setPromoCode(e.target.value)}
                                    />
                                    <button className="promo-btn">Apply</button>
                                </div>
                            </div>

                            {/* Payment Methods */}
                            <div className="payment-section">
                                <div className="section-title" style={{ marginBottom: '12px' }}>Payment Method</div>
                                <div className={`payment-option ${paymentMethod === 'wechat' ? 'active' : ''}`}
                                    onClick={() => setPaymentMethod('wechat')}>
                                    <div className="payment-info">
                                        <div className="payment-icon">💚</div>
                                        <span>WeChat Pay</span>
                                    </div>
                                </div>
                                <div className={`payment-option ${paymentMethod === 'alipay' ? 'active' : ''}`}
                                    onClick={() => setPaymentMethod('alipay')}>
                                    <div className="payment-info">
                                        <div className="payment-icon">💙</div>
                                        <span>Alipay</span>
                                    </div>
                                </div>
                                <div className={`payment-option ${paymentMethod === 'card' ? 'active' : ''}`}
                                    onClick={() => setPaymentMethod('card')}>
                                    <div className="payment-info">
                                        <div className="payment-icon">💳</div>
                                        <span>Credit Card</span>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Info */}
                            <div className="contact-section">
                                <div className="section-title" style={{ marginBottom: '12px' }}>Contact Information</div>
                                <input className="contact-input" placeholder="Phone Number" />
                                <input className="contact-input" placeholder="Email Address" />
                            </div>

                            {/* Security Notice */}
                            <div className="security-notice">
                                🔒 Secure checkout • Your information is protected • Instant confirmation
                            </div>
                        </>
                    )}
                </div>

                {/* Fixed Checkout Bar */}
                <div className="checkout-bar">
                    <div className="checkout-total">$1739</div>
                    <button className="checkout-btn">
                        {activeTab === 'checkout' ? 'Confirm Payment' : 'Checkout (3)'}
                    </button>
                </div>
            </div>
        </>
    );
};

export default BookingCart;